import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { useGetStakeTokenBalanceQuery } from 'modules/api/actions/getStakeTokenBalance';
import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { DECIMAL_PLACES_SHORT, ZERO } from 'modules/common/const';
import { stakeTokenIcon } from 'modules/common/icons';
import { Guide } from 'modules/deprecatedLiquidStaking/components/Guide/Guide';
import { useTranslation } from 'modules/i18n';
import { TokenDetails } from 'modules/liquidStaking/components/TokenDetails';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';
import { useStakeToken } from 'modules/liquidStaking/hooks/useStakeToken';

import { translation } from './translation';
import { useStyles } from './useStyles';

export function DeprecatedContent(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);

  const { poolAddress } = useLiquidStakingPool();
  const { name, address } = useStakeToken(poolAddress);

  const { isConnected, connectionKey } = useConnection();
  const { data: balance = ZERO } = useGetStakeTokenBalanceQuery(
    { connectionKey, poolAddress },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
    },
  );

  return (
    <div className={classes.root}>
      <TokenDetails
        address={address}
        icon={stakeTokenIcon}
        title={t(keys.title, { stakeToken: name })}
      />

      {balance?.isGreaterThan(ZERO) && (
        <>
          <Typography variant="body1">
            {t(
              keys.description,
              {
                token: name,
                amount: balance.decimalPlaces(DECIMAL_PLACES_SHORT).toFormat(),
              },
              true,
            )}
          </Typography>

          <Guide className={classes.guide} />

          <Typography variant="body1">{t(keys.note)}</Typography>
        </>
      )}
    </div>
  );
}
